import { render, staticRenderFns } from "./DebtPlanSelector.vue?vue&type=template&id=6d90169d&scoped=true&"
import script from "./DebtPlanSelector.vue?vue&type=script&lang=js&"
export * from "./DebtPlanSelector.vue?vue&type=script&lang=js&"
import style0 from "./DebtPlanSelector.vue?vue&type=style&index=0&id=6d90169d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../bankari hypo/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d90169d",
  null
  
)

export default component.exports